import styled from '@emotion/styled';
import { Loader } from 'src/domains/layouts/webview/components/loader/Loader';
import { withConfig } from 'src/withConfig';

export const WorldpayLoaderWrapper = styled(Loader, { label: 'WorldpayLoaderWrapper' })`
    justify-content: center;
    left: 0;
    margin: -6px auto auto;
    position: absolute;
    right: 0;
    top: 50%;
`;

export const WorldpayForm = withConfig(theme => styled('form', { label: 'WorldpayForm' })`
    display: flex;
    flex-direction: column;
    gap: ${theme.star.gap.large};
    padding: ${theme.star.padding.large} 0;
`);

export const WorldpaySavedMethodsWrapper = withConfig(theme => styled('div', { label: 'WorldpaySavedMethodsWrapper' })`
    display: flex;
    flex-direction: column;
    gap: ${theme.star.gap.small};

    & [data-test='select-input-label'] {
        color: ${theme.star.topUp.txtColor};
        font-size: ${theme.star.fontSize.small};
        font-weight: ${theme.star.fontWeight.bold};
        margin-top: 0;
    }

    & .custom-dropdown-select .react-select__control {
        min-height: 44px;
        height: 44px;
        padding: 0 12px;
        border: 1px solid ${theme.star.form.borderColorSecondary};
        border-radius: ${theme.star.radius.small};
        background: ${theme.star.form.light.bgColor};
        box-shadow: none;
    }

    & .custom-dropdown-select .react-select__control--is-focused {
        border-color: ${theme.star.form.borderColor};
        box-shadow: none;
    }

    & .custom-dropdown-select .react-select__value-container {
        padding: 0;
    }

    & .custom-dropdown-select .react-select__single-value,
    & .custom-dropdown-select .react-select__placeholder {
        color: ${theme.star.form.light.txtColor};
        font-size: ${theme.star.fontSize.small};
        margin: 0;
    }

    & .custom-dropdown-select .react-select__indicators {
        padding: 0;
    }

    & .custom-dropdown-select .react-select__menu {
        margin-top: 8px;
    }
`);

export const WorldpayFrameWrapper = styled('div', { label: 'WorldpayFrameWrapper' })<{ hidden: boolean }>`
    display: ${({ hidden }): string => (hidden ? 'none' : 'block')};
`;

export const WorldpayChallengeWrapper = styled('div', { label: 'WorldpayChallengeWrapper' })`
    display: flex;
    justify-content: center;
    width: 100%;
    height: 100%;
`;

export const WorldpayChallengeIframe = styled('iframe', { label: 'WorldpayChallengeIframe' })`
    width: min(390px, calc(100vw - 32px));
    height: 100%;
    min-height: 400px;
    border: none;
    display: block;
`;

export const WorldpayChallengeForm = styled('form', { label: 'WorldpayChallengeForm' })`
    display: none;
`;

export const WorldpayFieldGroup = styled('div', { label: 'WorldpayFieldGroup' })`
    display: flex;
    gap: 16px;
`;

export const WorldpayFieldWrapper = withConfig(theme => styled('div', { label: 'WorldpayFieldWrapper' })`
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: ${theme.star.gap.small};
`);

export const WorldpayFieldLabel = withConfig(theme => styled('label', { label: 'WorldpayFieldLabel' })`
    font-size: ${theme.star.fontSize.small};
    font-weight: ${theme.star.fontWeight.bold};
    color: ${theme.star.topUp.txtColor};
`);

export const WorldpayTextInput = withConfig(theme => styled('input', { label: 'WorldpayTextInput' })`
    height: 44px;
    width: 100%;
    border: 1px solid ${theme.star.form.borderColorSecondary};
    border-radius: ${theme.star.radius.small};
    background: ${theme.star.form.light.bgColor};
    padding: 0 ${theme.star.padding.medium};
    font-size: ${theme.star.fontSize.small};
    color: ${theme.star.form.light.txtColor};
    box-sizing: border-box;
    outline: none;

    &:focus {
        border-color: ${theme.star.form.borderColor};
    }
`);

export const WorldpayField = withConfig(theme => styled('div', { label: 'WorldpayField' })`
    height: 44px;
    border: 1px solid ${theme.star.form.borderColorSecondary};
    border-radius: ${theme.star.radius.small};
    background: ${theme.star.form.light.bgColor};
    padding: 0 ${theme.star.padding.medium};
`);

export const WorldpaySubmitButton = withConfig(theme => styled('button', { label: 'WorldpaySubmitButton' })`
    width: 100%;
    padding: ${theme.star.padding.xMedium};
    background: ${theme.star.buttons.primary.bgColor};
    color: ${theme.star.buttons.primary.txtColor};
    font-size: ${theme.star.fontSize.small};
    font-weight: ${theme.star.fontWeight.bold};
    border: none;
    border-radius: ${theme.star.radius.small};
    cursor: pointer;
    margin-top: ${theme.star.gap.medium};

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`);
